module.exports = __webpack_public_path__ + "static/media/planner_image.26cd4112.jpeg";